import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ILoaderState } from '../../interfaces/loader.interface';
import { LoaderService } from '../../services/loader/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit, OnDestroy {

  private subscription: Subscription;
  show = false;
  msg = '';

  constructor(
    private loaderService: LoaderService,
  ) {}

  ngOnInit(): void {
    this.subscription = this.loaderService.loaderState
    .subscribe((state: ILoaderState) => {
      this.show = state.show;
      this.msg = state.msg;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
